module.exports = __webpack_public_path__ + "media/images/articles/default-56a28645e58bbf27011f520242a888d9.jpg";